/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Ref_N6Inputs */

const en_to_csv_ref_n6 = /** @type {(inputs: To_Csv_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written as an empty cell. A missing key produces the same result, so the two are indistinguishable.`)
};

const ko_to_csv_ref_n6 = /** @type {(inputs: To_Csv_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`빈 칸으로 기록됩니다. 키가 없을 때도 결과가 같으므로 둘을 구분할 수 없습니다.`)
};

const ja_to_csv_ref_n6 = /** @type {(inputs: To_Csv_Ref_N6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空のセルとして書かれます。キーがない場合も同じ結果なので、両者は区別できません。`)
};

/**
* | output |
* | --- |
* | "Written as an empty cell. A missing key produces the same result, so the two are indistinguishable." |
*
* @param {To_Csv_Ref_N6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_ref_n6 = /** @type {((inputs?: To_Csv_Ref_N6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Ref_N6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_ref_n6(inputs)
	if (locale === "ko") return ko_to_csv_ref_n6(inputs)
	return ja_to_csv_ref_n6(inputs)
});